import { apiFetch } from "../../toolympus/api/core";
import { useItemActionWithConfirmation } from "../../toolympus/api/useAction";
import { useEditItem2, useNewItem, withActionOnSaveItem } from "../../toolympus/api/useNewItem";
import { useLoadedData } from "../../toolympus/hooks/useLoadedData";
import { FieldType, Schema } from "../../toolympus/hooks/useSchema";

export interface IssueContentItem {
  issue_id: number; // bigint, primary key
  item_id: number; // bigserial, primary key

  author?: string | null;
  is_unlisted_author?: boolean; // default: false

  title?: string | null;
  subtitle?: string | null;
  item_format?: string | null;

  page_nbr?: number | null; // integer
  page_nbr_display?: string | null;

  sort_order?: number; // float, default 0.0

  issue_title?: string | null;
}


export const IssueContentItemSchema: Schema = {
  author: { label: "Автор" },
  title: { label: "Название" },
  subtitle: { label: "Подзаголовок" },
  item_format: { label: "Формат" },
  page_nbr: { label: "Страница", type: FieldType.number },
  page_nbr_display: { label: "Страница отображаемая" },
  is_unlisted_author: { label: "Автор не автор", type: FieldType.bool },
}


export const useEditIssueContent = (issueId: number | string) => {
  const data = useLoadedData<IssueContentItem[]>(`/api/issues/${issueId}/content-item`, [], !!issueId);

  const newItem = useNewItem<Partial<IssueContentItem>, IssueContentItem>(
    `/api/issues/${issueId}/content-item`, { }, {

    }
  )

  const editItem = useEditItem2<IssueContentItem>({
    getApiPath: r => `/api/issues/${issueId}/content-item/${r.item_id}`,
  })

  const removeItem = useItemActionWithConfirmation<IssueContentItem, {}>(
    item => apiFetch(`/api/issues/${issueId}/content-item/${item.item_id}`, "delete").then(() => { data.reload(); editItem.cancel(); return {} }),
    {
      memoTrigger: issueId,
      title: "Удалить",
    }
  )

  const importItems = useEditItem2<{ items_text: string }>({
    save: async (x) => {
      const items = x.items_text.split("\n").map(s => s.trim()).filter(x => !!x)
        .map(s => s.split("\t"))
        .map(([author,title,subtitle,format,page]) => ({
          author: author?.trim() || "",
          title: title?.trim() || "",
          subtitle: subtitle?.trim() || "",
          item_format: format?.trim() || "",
          page_nbr: +(page?.trim() || "") || 0,
        }));
      if(items.length) {
        for (const item of items) {
          await apiFetch(`/api/issues/${issueId}/content-item`, "post", item);
        }
      }

      data.reload();
      return x;
    }
  })

  
  return {
    ...data,
    schema: IssueContentItemSchema,
    newItem: withActionOnSaveItem(newItem, () => data.reload()),
    editItem: withActionOnSaveItem(editItem, () => data.reload()),
    removeItem,

    importItems,
  }
}
